import React from 'react'
import { PropTypes } from 'prop-types'
import { hideAlert } from '../../state/actions/stepActions'
import { connect } from 'react-redux'

import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'

const AlertModal = props => {
  const handleClick = (/*e*/) => {
    const { dispatch, component } = props
    dispatch(hideAlert(component))
  }
 const renderLabel=()=> {
    if (props.content && props.content.split('<br><br>').length > 1) {
      const description = props.content.split('<br><br>')
      return description.map((s, index) => (
        <span key={index}>
          {s}
          <br />
        </span>
      ))
    } else return props.content
  }
  return (
    <div
      {...css(
        props.styles.modal,
        !!props.hidden && props.styles['modal--hidden']
      )}
    >
      {/* <div {...css(props.styles.bg)} /> */}
      <div {...css(props.styles.header)}>
        <div {...css(props.styles.title)}>
          <span> {props.title}</span>
        </div>
        <div
          {...css(props.styles.closeBtn)}
          onClick={event => handleClick(event)}
        />
      </div>

      <div {...css(props.styles.wrapper)}>
        <div {...css(props.styles.content)}>{renderLabel()}</div>
      </div>
    </div>
  )
}

AlertModal.propTypes = {
  // children: PropTypes.node,
  title: PropTypes.string,
  content: PropTypes.string
  // hidden: PropTypes.bool
}

const mapStateToProps = state => {
  const { step } = state
  return { step }
}

export default connect(mapStateToProps)(withStyles(Styles)(AlertModal))



// WEBPACK FOOTER //
// ./components/alertModal/index.js